<template>
  <JadeBox :hasPadding="false">
    <div class="box">
      <div>
        <jade-text
          class="title"
          variant="heading-medium"
        >
          {{ title }}
        </jade-text>

        <jade-text
          v-if="!$slots.description"
          class="description"
          variant="text-medium"
        >
          {{ description }}
        </jade-text>
        <div
          v-else
          class="description"
        >
          <slot name="description" />
        </div>
        <slot name="trailing" />
      </div>
      <img
        :src="imageUrl"
        width="82"
        height="82"
      />
    </div>
  </JadeBox>
</template>
<script>
import JadeBox from '@jade/JadeBox'
import JadeText from '@jade/JadeText'

export default {
  name: 'StatusTemplate',
  components: {
    JadeBox,
    JadeText
  },
  props: {
    title: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    description: String
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';

.box {
  display: flex;
  justify-content: space-between;
  padding: var(--global-space-250);
}

.title {
  margin-bottom: var(--global-space-100);
}

.description {
  margin-bottom: var(--global-space-250);
}
</style>
